import { ChangeDetectionStrategy, Component } from '@angular/core';

@Component({
	changeDetection: ChangeDetectionStrategy.OnPush,
	selector: 'bp-icon-contact-trace',
	templateUrl: './icon-contact-trace.component.svg',
})
export class IconContactTraceComponent {}
